export default __webpack_public_path__ + "static/media/logo1.dcb52722.png";